module.exports = __webpack_public_path__ + "static/media/oweis.870f391d.png";